import firebase_store from "../firebase";

const db = firebase_store;

export const getCode = async (code, onSuccess) => {
  await db
    .collection("redeemCode_BatTu_Fengshui")
    .doc(code)
    .get()
    .then((doc) => {
      if (doc.exists) {
        if (doc?.data()?.level === 1 && doc?.data()?.isActive === false) {
          updateUser(
            3,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          updateCode(
            code,
            doc.data().level,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          onSuccess("success");
        } else if (
          doc?.data()?.level === 2 &&
          doc?.data()?.isActive === false
        ) {
          updateUser(
            6,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          updateCode(
            code,
            doc.data().level,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          onSuccess("success");
        } else if (
          doc?.data()?.level === 3 &&
          doc?.data()?.isActive === false
        ) {
          updateUser(
            12,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          updateCode(
            code,
            doc.data().level,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          onSuccess("success");
        } else if (
          doc?.data()?.level === 4 &&
          doc?.data()?.isActive === false
        ) {
          updateUser(
            36,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          updateCode(
            code,
            doc.data().level,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          onSuccess("success");
        } else if (
          doc?.data()?.level === 5 &&
          doc?.data()?.isActive === false
        ) {
          updateUser(
            1200,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          updateCode(
            code,
            doc.data().level,
            doc?.data()?.enableThanSat,
            doc?.data()?.enableHoaGiap,
            doc?.data()?.enableNguoiNoiTieng,
            doc?.data()?.enableTieuNhi,
            doc?.data()?.enableTinhCach,
            doc?.data()?.enableDungThanDieuHau,
            doc?.data()?.enableNguHanh
          );
          onSuccess("success");
        }
        if (doc?.data()?.isActive === true) {
          onSuccess("exist");
        }
      } else {
        onSuccess("fail");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
  // return 'haha';
};

export const getCodeDungThan = async (code, onSuccess) => {
  await db
    .collection("code_dungThanBatTu")
    .doc(code)
    .get()
    .then((doc) => {
      if (doc.exists) {
        if (doc?.data()?.level === 1 && doc?.data()?.isActive === false) {
          updateUserV2(3);
          updateCodeV2(code, doc?.data()?.level);
          onSuccess("success");
        } else if (
          doc?.data()?.level === 2 &&
          doc?.data()?.isActive === false
        ) {
          updateUserV2(6);
          updateCodeV2(code, doc?.data()?.level);
          onSuccess("success");
        } else if (
          doc?.data()?.level === 3 &&
          doc?.data()?.isActive === false
        ) {
          updateUserV2(12);
          updateCodeV2(code, doc?.data()?.level);
          onSuccess("success");
        } else if (
          doc?.data()?.level === 4 &&
          doc?.data()?.isActive === false
        ) {
          updateUserV2(36);
          updateCodeV2(code, doc?.data()?.level);
          onSuccess("success");
        } else if (
          doc?.data()?.level === 5 &&
          doc?.data()?.isActive === false
        ) {
          updateUserV2(1200);
          updateCodeV2(code, doc?.data()?.level);
          onSuccess("success");
        }
        if (doc?.data()?.isActive === true) {
          onSuccess("exist");
        }
      } else {
        onSuccess("fail");
      }
    });
};

export const getCodeCaiDatDungThan = async (code, onSuccess) => {
  await db
    .collection("code_caiDatDungThan")
    .doc(code)
    .get()
    .then(async (doc) => {
      if (doc.exists && doc?.data()?.isActive === false) {
        await updateUserCaiDatDungThan();
        updateCodeCaiDatDungThan(code);
        onSuccess("success");
      } else if (doc.exists && doc?.data()?.isActive === true) {
        onSuccess("exist");
      } else {
        onSuccess("fail");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
      onSuccess("fail");
    });
};

export const getCodeDungThanByBirthDate = async (
  code,
  birthDate,
  onSuccess
) => {
  await db
    .collection("code_dungThanBatTuTheoNgaySinh")
    .doc(code)
    .get()
    .then(async (doc) => {
      if (doc.exists && doc?.data()?.isActive === false) {
        const level = doc?.data()?.level;
        // Map level to months: level 1 = 12 months (1 năm), level 2 = 36 months (3 năm), level 3 = 1200 months (vĩnh viễn)
        let months = 0;
        if (level === 1) months = 12;
        else if (level === 2) months = 36;
        else if (level === 3) months = 1200;

        // Check if birthDate already exists before updating
        const updateResult = await updateUserV2WithBirthDate(birthDate, months);
        if (updateResult === "birthDate_exist") {
          onSuccess("birthDate_exist");
          return;
        }
        // Update code to mark as active
        updateCodeV2ForBirthDate(code, birthDate, level);
        onSuccess("success");
      } else if (doc.exists && doc?.data()?.isActive === true) {
        onSuccess("exist");
      } else {
        onSuccess("fail");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
      onSuccess("fail");
    });
};

const updateCode = (
  code,
  level,
  isActiveThanSat,
  isActiveHoaGiap,
  isActiveNguoiNoiTieng,
  isActiveTieuNhi,
  isActiveTinhCach,
  isActiveDungThanDieuHau,
  isActiveNguHanh
) => {
  db.collection("redeemCode_BatTu_Fengshui")
    .doc(code)
    .set({
      isActive: true,
      level: level,
      isActiveThanSat:
        isActiveThanSat !== undefined && isActiveThanSat === true,
      isActiveHoaGiap:
        isActiveHoaGiap !== undefined && isActiveHoaGiap === true,
      isActiveNguoiNoiTieng:
        isActiveNguoiNoiTieng !== undefined && isActiveNguoiNoiTieng === true,
      isActiveTieuNhi:
        isActiveTieuNhi !== undefined && isActiveTieuNhi === true,
      isActiveTinhCach:
        isActiveTinhCach !== undefined && isActiveTinhCach === true,
      isActiveDungThanDieuHau:
        isActiveDungThanDieuHau !== undefined &&
        isActiveDungThanDieuHau === true,
      isActiveNguHanh:
        isActiveNguHanh !== undefined && isActiveNguHanh === true,
    });
};

const updateCodeV2 = (code, level) => {
  db.collection("code_dungThanBatTu").doc(code).set({
    isActive: true,
    level: level,
  });
};

export const addUser = (user) => {
  db.collection("User_BatTu_FengSui")
    .doc(user.email)
    .get()
    .then((doc) => {
      if (doc.exists) {
        let currenDate = new Date();
        let expiredDatee = new Date(
          new Date(doc.data().expiredDate.seconds * 1000).toString()
        );

        let profileUser = {
          name: doc.data().name,
          email: doc.data().email,
          activeDate: new Date(doc.data().activeDate.seconds * 1000).toString(),
          isActive: doc.data().isActive,
          isActiveThanSat: doc.data().isActiveThanSat,
          isActiveHoaGiap: doc.data().isActiveHoaGiap,
          isActiveNguoiNoiTieng: doc.data()?.isActiveNguoiNoiTieng,
          isActiveTieuNhi: doc.data()?.isActiveTieuNhi,
          isActiveTinhCach: doc.data()?.isActiveTinhCach,
          isActiveDungThanDieuHau: doc.data()?.isActiveDungThanDieuHau,
          isActiveNguHanh: doc.data()?.isActiveNguHanh,
          isActiveDungThan: doc.data()?.isActiveDungThan,
          isActiveDungThanCaiDat: doc.data()?.isActiveDungThanCaiDat ?? false,
          dungThanBirthDays: doc.data()?.dungThanBirthDays ?? [],
          dungThanCaiDatDiaChi: doc.data()?.dungThanCaiDatDiaChi ?? [],
          dungThanCaiDatThienCan: doc.data()?.dungThanCaiDatThienCan ?? [],

          expiredDate: new Date(
            doc.data().expiredDate.seconds * 1000
          ).toString(),
        };

        if (expiredDatee > currenDate) {
          localStorage.setItem("profile", JSON.stringify(profileUser));
          window.location.reload(false);
        } else {
          localStorage.setItem("profile", JSON.stringify(profileUser));

          db.collection("User_BatTu_FengSui").doc(user.email).set(profileUser);
          window.location
            .reload()

            .catch((err) => {
              console.error(err);
            });
        }
      } else {
        let profileUserNew = {
          name: user.name,
          email: user.email,
          isActive: true,
          isActiveThanSat: false,
          isActiveHoaGiap: false,
          isActiveNguoiNoiTieng: false,
          isActiveTieuNhi: false,
          isActiveTinhCach: false,
          isActiveDungThanDieuHau: false,
          isActiveNguHanh: false,
          isActiveDungThan: false,
          isActiveDungThanCaiDat:false,
          dungThanCaiDatDiaChi: [],
          dungThanCaiDatThienCan: [],
          activeDate: new Date(),
          expiredDate: new Date(new Date().setDate(new Date().getDate() + 7)),
          dungThanBirthDays: [],
        };
        // doc.data() will be undefined in this case
        db.collection("User_BatTu_FengSui")
          .doc(user.email)
          .set(profileUserNew)
          .then(() => {
            localStorage.setItem("profile", JSON.stringify(profileUserNew));
            window.location.reload();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
};

export const updateUser = (
  level,
  isActiveThanSat,
  isActiveHoaGiap,
  isActiveNguoiNoiTieng,
  isActiveTieuNhi,
  isActiveTinhCach,
  isActiveDungThanDieuHau,
  isActiveNguHanh
) => {
  // return
  let currentDate = new Date();
  let expiredDate = new Date(
    JSON.parse(localStorage.getItem("profile"))?.expiredDate
  );

  if (Number.isNaN(expiredDate.getTime()) || currentDate > expiredDate) {
    expiredDate = currentDate;
  }

  let currentExpiredDate = expiredDate.setMonth(expiredDate.getMonth() + level);
  let newExpiredDate = new Date(currentExpiredDate);
  const dungThan = JSON.parse(
    localStorage.getItem("profile")
  )?.isActiveDungThan;

  let newUser = {
    name: JSON.parse(localStorage.getItem("profile"))?.name,
    email: JSON.parse(localStorage.getItem("profile"))?.email,
    isActive: true,
    isActiveThanSat: isActiveThanSat !== undefined && isActiveThanSat === true,
    isActiveHoaGiap: isActiveHoaGiap !== undefined && isActiveHoaGiap === true,
    isActiveNguoiNoiTieng:
      isActiveNguoiNoiTieng !== undefined && isActiveNguoiNoiTieng === true,
    isActiveTieuNhi: isActiveTieuNhi !== undefined && isActiveTieuNhi === true,
    isActiveTinhCach:
      isActiveTinhCach !== undefined && isActiveTinhCach === true,
    isActiveDungThanDieuHau:
      isActiveDungThanDieuHau !== undefined && isActiveDungThanDieuHau === true,
    isActiveNguHanh: isActiveNguHanh !== undefined && isActiveNguHanh === true,
    isActiveDungThan: dungThan,
    isActiveDungThanCaiDat: JSON.parse(localStorage.getItem("profile"))
      ?.isActiveDungThanCaiDat ?? false,
    activeDate: new Date(
      JSON.parse(localStorage.getItem("profile"))?.activeDate
    ),
    expiredDate: newExpiredDate,
    dungThanBirthDays: JSON.parse(localStorage.getItem("profile"))
      ?.dungThanBirthDays ?? [],
  };

  db.collection("User_BatTu_FengSui")
    .doc(JSON.parse(localStorage.getItem("profile"))?.email)
    .set(newUser);

  localStorage.setItem("profile", JSON.stringify(newUser));
};

const updateUserV2 = (level) => {
  let currentDate = new Date();
  let expiredDate = new Date(
    JSON.parse(localStorage.getItem("profile"))?.expiredDate
  );

  if (Number.isNaN(expiredDate.getTime()) || currentDate > expiredDate) {
    expiredDate = currentDate;
  }

  let currentExpiredDate = expiredDate.setMonth(expiredDate.getMonth() + level);

  let newExpiredDate = new Date(currentExpiredDate);
  const newUser = {
    ...JSON.parse(localStorage.getItem("profile")),
    isActiveDungThan: true,
    activeDate: new Date(
      JSON.parse(localStorage.getItem("profile"))?.activeDate
    ),
    expiredDate: newExpiredDate,
  };

  db.collection("User_BatTu_FengSui")
    .doc(JSON.parse(localStorage.getItem("profile"))?.email)
    .set(newUser);

  localStorage.setItem("profile", JSON.stringify(newUser));
};

const updateUserV2WithBirthDate = async (birthDate, months = 0) => {
  const email = JSON.parse(localStorage.getItem("profile"))?.email;
  if (!email) {
    console.error("No email found in profile");
    return "error";
  }

  // Parse birthDate correctly - handle DD/MM/YYYY format
  let birthDateObj;
  if (typeof birthDate === "string") {
    // Check if it's in DD/MM/YYYY format
    const dateMatch = birthDate.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (dateMatch) {
      const day = parseInt(dateMatch[1], 10);
      const month = parseInt(dateMatch[2], 10) - 1; // Month is 0-indexed
      const year = parseInt(dateMatch[3], 10);
      // Create date at 00:00:00 UTC to avoid timezone issues
      birthDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    } else {
      // Try to parse with convertToDate for other formats
      birthDateObj = convertToDate(birthDate);
      // If it's a valid date, normalize to UTC midnight
      if (birthDateObj && !Number.isNaN(birthDateObj.getTime())) {
        const year = birthDateObj.getFullYear();
        const month = birthDateObj.getMonth();
        const day = birthDateObj.getDate();
        birthDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      }
    }
  } else {
    birthDateObj = convertToDate(birthDate);
    // If it's a valid date, normalize to UTC midnight
    if (birthDateObj && !Number.isNaN(birthDateObj.getTime())) {
      const year = birthDateObj.getFullYear();
      const month = birthDateObj.getMonth();
      const day = birthDateObj.getDate();
      birthDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    }
  }

  if (!birthDateObj || Number.isNaN(birthDateObj.getTime())) {
    console.error("Invalid birthDate provided");
    return "error";
  }

  // Convert to ISO string for storage (like expiredDate and activeDate)
  const birthDateISOString = birthDateObj.toISOString();

  // Get current user data from Firestore
  const userDoc = await db.collection("User_BatTu_FengSui").doc(email).get();
  const currentUserData = userDoc.exists ? userDoc.data() : {};

  // Get existing dungThanBirthDays array - support both old format (string) and new format (object)
  const existingBirthDays = currentUserData.dungThanBirthDays || [];
  const normalizedBirthDays = existingBirthDays
    .map((item) => {
      // Handle new format: { birthDate, expiredDate }
      if (item && typeof item === "object" && item.birthDate) {
        const dateObj = convertToDate(item.birthDate);
        if (dateObj && !Number.isNaN(dateObj.getTime())) {
          const year = dateObj.getFullYear();
          const month = dateObj.getMonth();
          const day = dateObj.getDate();
          return {
            birthDate: new Date(Date.UTC(year, month, day, 0, 0, 0, 0)),
            expiredDate: item.expiredDate ? convertToDate(item.expiredDate) : null,
          };
        }
        return null;
      }
      // Handle old format: just a date string/object
      const dateObj = convertToDate(item);
      if (dateObj && !Number.isNaN(dateObj.getTime())) {
        const year = dateObj.getFullYear();
        const month = dateObj.getMonth();
        const day = dateObj.getDate();
        return {
          birthDate: new Date(Date.UTC(year, month, day, 0, 0, 0, 0)),
          expiredDate: null, // Old data doesn't have expiredDate
        };
      }
      return null;
    })
    .filter(Boolean);

  // Check if birthDate already exists by comparing timestamps
  const birthDateTimestamp = birthDateObj.getTime();
  const exists = normalizedBirthDays.some(
    (item) => item.birthDate.getTime() === birthDateTimestamp
  );

  if (exists) {
    console.log("birthDate already exists");
    return "birthDate_exist";
  }

  // Calculate expiredDate for this specific birthDate based on level (months)
  let currentDate = new Date();
  let birthDateExpiredDate = new Date(currentDate);
  if (months > 0) {
    birthDateExpiredDate.setMonth(birthDateExpiredDate.getMonth() + months);
  }

  // Convert existing birth days to new format for storage
  const existingBirthDaysFormatted = normalizedBirthDays.map((item) => ({
    birthDate: item.birthDate.toISOString(),
    expiredDate: item.expiredDate ? item.expiredDate.toISOString() : null,
  }));

  // Add new birthDate with its own expiredDate
  const newBirthDayEntry = {
    birthDate: birthDateISOString,
    expiredDate: months > 0 ? birthDateExpiredDate.toISOString() : null,
  };
  const updatedBirthDays = [...existingBirthDaysFormatted, newBirthDayEntry];

  const newUser = {
    ...JSON.parse(localStorage.getItem("profile")),
    dungThanBirthDays: updatedBirthDays,
  };

  await db.collection("User_BatTu_FengSui").doc(email).set(newUser);

  localStorage.setItem("profile", JSON.stringify(newUser));
  return "success";
};

const updateCodeV2ForBirthDate = (code, birthDate, level) => {
  db.collection("code_dungThanBatTuTheoNgaySinh").doc(code).set({
    isActive: true,
    birthDate: birthDate,
    level: level,
  });
};

const updateUserCaiDatDungThan = async () => {
  const newUser = {
    ...JSON.parse(localStorage.getItem("profile")),
    isActiveDungThanCaiDat: true,
  };

  await db.collection("User_BatTu_FengSui")
    .doc(JSON.parse(localStorage.getItem("profile"))?.email)
    .set(newUser);

  localStorage.setItem("profile", JSON.stringify(newUser));
};

const updateCodeCaiDatDungThan = (code) => {
  db.collection("code_caiDatDungThan").doc(code).set({
    isActive: true,
  });
};

export const saveDungThanCaiDat = async (email, thienCanArr, diaChiArr) => {
  const newUser = {
    ...JSON.parse(localStorage.getItem("profile")),
    dungThanCaiDatThienCan: thienCanArr,
    dungThanCaiDatDiaChi: diaChiArr,
  };

  await db.collection("User_BatTu_FengSui").doc(email).set(newUser);
  localStorage.setItem("profile", JSON.stringify(newUser));
};

export const SaveData = (data, onSuccess) => {
  db.collection("Data_BatTu")
    .get()
    .then((doc) => {
      const id = makeid(5);
      const content = JSON.parse(sessionStorage.getItem("note"));
      let updateData = {
        id: id,
        email: data.email,
        data: data.data,
        name: data.name,
        born: data.born,
        napAm: data.napAm,
        truongSinh: data.truongSinh,
        thanSat: data.thanSat,
        note: content ? content : data.note,
      };
      db.collection("Data_BatTu")
        .doc(id)
        .set(updateData)
        .then(() => {
          onSuccess(true);
        })
        .catch((err) => {
          onSuccess(false);
        });
    });
};

export const getData = async () => {
  let markers = [];
  const email = JSON.parse(localStorage.getItem("profile"))?.email;
  await db
    .collection("Data_BatTu")
    .get()
    .then((querySnapshot) => {
      querySnapshot.docs.forEach((doc) => {
        if (doc.data().email === email) {
          markers.push(doc.data());
        }
      });
    });

  markers.filter((item) => {
    return item.email === email;
  });
  // markers = [...new Map(markers.map(item =>
  //   [item['data'], item])).values()];

  return markers;
};

export const deleteDataSave = async (id, onSuccess) => {
  let query = db.collection("Data_BatTu").where("id", "==", id);
  query.get().then(function (querySnapshot) {
    querySnapshot.forEach(function (doc) {
      doc.ref.delete();
    });
  });
  onSuccess(true);
};

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const convertToDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === "object" && typeof value.toDate === "function") {
    return value.toDate();
  }

  if (typeof value === "object" && typeof value.seconds === "number") {
    return new Date(value.seconds * 1000);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const normalizeUserData = (data) => {
  if (!data) {
    return null;
  }

  // Normalize dungThanBirthDays - support both old format (date string) and new format (object with birthDate & expiredDate)
  const normalizedBirthDays = data.dungThanBirthDays
    ? data.dungThanBirthDays.map((item) => {
        // New format: { birthDate, expiredDate }
        if (item && typeof item === "object" && item.birthDate) {
          return {
            birthDate: convertToDate(item.birthDate),
            expiredDate: item.expiredDate ? convertToDate(item.expiredDate) : null,
          };
        }
        // Old format: just a date string/object - convert to new format
        const dateObj = convertToDate(item);
        if (dateObj) {
          return {
            birthDate: dateObj,
            expiredDate: null,
          };
        }
        return null;
      }).filter(Boolean)
    : [];

  return {
    name: data.name ?? "",
    email: data.email ?? "",
    isActive: data.isActive ?? false,
    isActiveThanSat: !!data.isActiveThanSat,
    isActiveHoaGiap: !!data.isActiveHoaGiap,
    isActiveNguoiNoiTieng: !!data.isActiveNguoiNoiTieng,
    isActiveTieuNhi: !!data.isActiveTieuNhi,
    isActiveTinhCach: !!data.isActiveTinhCach,
    isActiveDungThanDieuHau: !!data.isActiveDungThanDieuHau,
    isActiveNguHanh: !!data.isActiveNguHanh,
    isActiveDungThan: !!data.isActiveDungThan,
    isActiveDungThanCaiDat: !!data.isActiveDungThanCaiDat,
    activeDate: convertToDate(data.activeDate),
    expiredDate: convertToDate(data.expiredDate),
    dungThanBirthDays: normalizedBirthDays,
    dungThanCaiDatDiaChi: data.dungThanCaiDatDiaChi,
    dungThanCaiDatThienCan: data.dungThanCaiDatThienCan,
  };
};

export const fetchUserProfileFromDB = async (email) => {
  if (!email) {
    return null;
  }

  try {
    const doc = await db.collection("User_BatTu_FengSui").doc(email).get();
    if (!doc.exists) {
      return null;
    }
    return normalizeUserData(doc.data());
  } catch (error) {
    console.error("Error fetching user profile from Firestore:", error);
    throw error;
  }
};

export const syncUserProfileFromDB = async () => {
  const rawProfile = localStorage.getItem("profile");

  if (!rawProfile) {
    return null;
  }

  let storedProfile;
  try {
    storedProfile = JSON.parse(rawProfile);
  } catch (error) {
    console.error(
      "Invalid profile data in localStorage. Clearing profile:",
      error
    );
    localStorage.removeItem("profile");
    return null;
  }

  const email = storedProfile?.email;
  if (!email) {
    return null;
  }

  const profile = await fetchUserProfileFromDB(email);
  if (!profile) {
    return null;
  }

  const profileForStorage = {
    ...profile,
    activeDate: profile.activeDate ? profile.activeDate.toISOString() : null,
    expiredDate: profile.expiredDate ? profile.expiredDate.toISOString() : null,
    dungThanBirthDays: profile.dungThanBirthDays
      ? profile.dungThanBirthDays
          .map((item) => {
            if (item && item.birthDate) {
              return {
                birthDate: item.birthDate.toISOString(),
                expiredDate: item.expiredDate ? item.expiredDate.toISOString() : null,
              };
            }
            return null;
          })
          .filter(Boolean)
      : [],
  };

  localStorage.setItem("profile", JSON.stringify(profileForStorage));
  return profileForStorage;
};
